export default __webpack_public_path__ + "static/media/dt5.2b418b3a.jpg";